export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TableAdvances.vue?vue&type=template&id=2687b949&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/PurchaseOrderTracking/TableAdvances.vue?vue&type=template&id=2687b949&scoped=true
// module id = 2360
// module chunks = 31